// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trade-buy-sell-header[data-v-f28e2a5e]{display:flex;justify-content:flex-end;overflow-x:auto;max-height:2.8125rem}@media(min-width:992px){.trade-buy-sell-header[data-v-f28e2a5e]{justify-content:space-between}}.trade-buy-sell-header__balance[data-v-f28e2a5e]{display:flex;align-items:center;white-space:nowrap}.trade-buy-sell-header__title[data-v-f28e2a5e]{margin-right:auto;display:flex;align-items:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
